import { CheckCircleIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import CiroSpinner from "../../../shared/CiroSpinner";
import { gql } from "@apollo/client";
import { CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStepFragment } from "../../../../__generated__/graphql";

export const CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStep = gql`
  fragment CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStep on AutopilotSearchDesignTextOnlyStep {
    jobId
    jobIsComplete
    textOnlyData {
      text
    }
  }
`;

const CuratedSearchDesignTextOnlyStep = ({
  data,
  isCurrentStep,
}: {
  data: CuratedSearchDesignTextOnlyStep_AutopilotSearchDesignTextOnlyStepFragment;
  isCurrentStep: boolean;
  }) => {
  
  const jobIsInProgress = !data?.jobIsComplete;
  const isLoading = isCurrentStep && jobIsInProgress;
  
  return (
    <div className="flex gap-4 items-center">
      <div className={classNames("w-6", "flex-shrink-0")}>
        {isLoading ? (
          <CiroSpinner loading />
        ) : (
          <CheckCircleIcon
            className={classNames("w-5", "h-5", "text-orange-400")}
          />
        )}
      </div>
      <div
        className={classNames(
          "text-sm",
          isCurrentStep ? "text-gray-800" : "text-gray-600",
        )}
      >
        {data.textOnlyData.text}
      </div>
    </div>
  );
};

export default CuratedSearchDesignTextOnlyStep;
